import '.e{flex-shrink:0;}.ssr-plugin'
import '.k{padding:1rem;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.c5{height:100%;}.ssr-plugin'
import '.bw{border:none;}.ssr-plugin'
import '.bx{background-color:transparent;}.ssr-plugin'
import '.gc{border-radius:0px;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.az{align-items:stretch;}.ssr-plugin'
import '.el{position:sticky;}.ssr-plugin'
import '.gd{top:4rem;}.ssr-plugin'
import '.ge{z-index:7;}.ssr-plugin'
import '.b2{background-color:var(--palette-white);}.ssr-plugin'
import '.gf{padding-bottom:1rem;}.ssr-plugin'
import '.au{margin-bottom:1rem;}.ssr-plugin'
import '.gg{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.ao{position:fixed;}.ssr-plugin'
import '.dd{top:0;}.ssr-plugin'
import '.c3{left:0px;}.ssr-plugin'
import '.c4{right:0px;}.ssr-plugin'
import '.gh{bottom:0px;}.ssr-plugin'
import '.gi{z-index:9999;}.ssr-plugin'
import '.gj{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cs{justify-content:flex-end;}.ssr-plugin'
import '.d4{flex:1;}.ssr-plugin'
import '.bl{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="e k h c5 bw bx gc"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="l m az"
    >
      <div className="el gd ge b2 gf au gg l"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="ao dd c3 c4 gh gi b2 gj l m"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="k l cs gg"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="d4 bl">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
